import { useEffect } from "react";
import { useTheme } from "./__product__/theme/Theme.context";
import { ThemeEnum } from "./__product__/theme/Theme.model";
import OnlineMenuService from "./api/service/OnlineMenuService";
import i18n from "./__product__/language/i18n";

const AppHook = () => {
  const { setCurrentTheme } = useTheme();
  const { getOnlineMenuLanguages } = OnlineMenuService();

  useEffect(() => {
    void getOnlineMenuLanguages().then((value) => {
      const lng =
        value.responseModel.length > 0
          ? value.responseModel.find((r) => r.language === navigator.language)
              ?.language ?? value.responseModel[0].language
          : "tr";
      void i18n.changeLanguage(lng);
    });
  }, []);

  useEffect(() => {
    const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
    if (!localStorage.getItem("theme") && darkThemeMq.matches) {
      setCurrentTheme(ThemeEnum.DARK);
    } else {
      setCurrentTheme(ThemeEnum.LIGHT);
    }
  }, []);
};
export default AppHook;
